import { useMutation } from '@w/react-query'
import { Button } from '@w/ui/components/button'
import { useRouterContext } from '../router/flashcards-fe.router-bindings'

/** No content file means no empty-page creation or completed training state. */
export function FirstDownloadPage() {
  const ctx = useRouterContext()
  const refresh = useMutation({ mutationFn: async (workspaceId: string) => {
    // This workspace cannot open until its content has arrived from the server.
    await ctx.spaces.trigger(workspaceId, true, ctx.tel)
    if (ctx.spaces.snapshot(workspaceId).resources.length > 0) window.location.reload()
  } })
  return <main className="flex flex-col gap-4 p-6">
    <nav aria-label="Pages" data-testid="flashcards-page-tree">
      <p>First download needed</p>
      <p>Connect to download this workspace before opening pages or training.</p>
    </nav>
    <Button disabled={refresh.isPending} onClick={() => { refresh.mutate(ctx.getUser().id) }}>Refresh</Button>
    {refresh.error && <p role="alert">{refresh.error.message}</p>}
  </main>
}
